import { LicensePackage } from '@account-users/account/models';
import { AccountCategory } from '@account-users/account/models/AccountCategory';
import { AccountState, IAccount } from '@account-users/account/models/IAccount';
import { Permission } from '@account-users/account/models/Permission';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-accounts-table',
  templateUrl: './accounts-table.component.html',
  styleUrls: ['./accounts-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountsTableComponent {
  @Input() accounts: IAccount[];
  @Input() isLoadingAccounts = false;
  @Input() licensePackages: LicensePackage[] = [];
  @Input() accountCategories: AccountCategory[] = [];
  @Input() userPermissions: Permission[] = [];
  @Input() sortOnAscending$: Observable<boolean>;
  @Input() loadAllAccounts = false;
  @Output() sortAccounts = new EventEmitter();
  @Output() loadAllHit = new EventEmitter();

  licensePackageMap(code: string) {
    return (
      this.licensePackages.find((pkg) => pkg.code === code)?.displayName ?? code
    );
  }

  accountCategoriesMap(categoryCode) {
    const accountCategory = this.accountCategories.find(
      (ac) => ac.code === categoryCode,
    );
    return accountCategory ? accountCategory.displayName : '';
  }

  get canRemoveAccount() {
    return this.userPermissions.includes(Permission.CanCreateAccount);
  }

  getAccountStateClass(state: AccountState) {
    switch (state) {
      case AccountState.Failed:
        return 'danger';
      case AccountState.Success:
        return 'success';
      case AccountState.Pending:
        return 'warning';
      default:
        return '';
    }
  }

  loadAll() {
    this.loadAllHit.emit();
  }

  queryParams(account: IAccount) {
    let params = {};
    if (account.state === AccountState.Deleted) {
      params = { deleted: true };
    }
    return params;
  }
}
